import { styled, Typography } from '@mui/material';

export const TypographyElipsis = styled(Typography)`
  overflow: hidden;
  text-overflow: ellipsis;
`;
